import Dom from './dom.js'
import Vue from 'vue'

// var hasModal = false
let hasInitZIndex = false
let zIndex = 2000

const getModal = function () {
  if (Vue.prototype.$isServer) return
  let modalDom = Popup.modalDom
  if (modalDom) {
    // hasModal = true
  } else {
    // hasModal = false
    modalDom = document.createElement('div')
    Popup.modalDom = modalDom

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault()
      event.stopPropagation()
    })

    modalDom.addEventListener('click', function (event) {
      event.stopPropagation()
      Popup.doOnModalClick && Popup.doOnModalClick()
    })
  }

  return modalDom
}

const instances = {}

const Popup = {

  getInstance: function (id) {
    return instances[id]
  },

  register: function (id, instance) {
    if (id && instance) {
      instances[id] = instance
    }
  },

  deregister: function (id) {
    if (id) {
      instances[id] = null
      delete instances[id]
    }
  },

  nextZIndex: function () {
    return Popup.zIndex++
  },

  modalStack: [],

  doOnModalClick: function () {
    const topItem = Popup.modalStack[Popup.modalStack.length - 1]
    if (!topItem) return

    const instance = Popup.getInstance(topItem.id)
    if (instance && instance.onClickCloseModal) {
      instance.close()
    }
  },

  openModal: function (id, zIndex, dom) {
    if (Vue.prototype.$isServer) return
    if (!id || zIndex === undefined) return
    const modalStack = this.modalStack

    for (let i = 0, j = modalStack.length; i < j; i++) {
      const item = modalStack[i]
      if (item.id === id) {
        return
      }
    }

    const modalDom = getModal()

    Dom.addClass(modalDom, 'v-modal')
    Dom.addClass(modalDom, 'v-model-fade-enter')

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom)
    } else {
      document.body.appendChild(modalDom)
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex
    }

    modalDom.tabIndex = 0
    modalDom.style.display = ''

    this.modalStack.push({ id: id, zIndex: zIndex})
  },

  closeModal: function (id) {
    const modalStack = this.modalStack
    const modalDom = getModal()

    if (modalStack.length > 0) {
      const topItem = modalStack[modalStack.length - 1]
      if (topItem.id === id) {
        if (topItem.modalClass) {
          // let classArr = topItem.modalClass.trim().split(/\s+/)
          // classArr.forEach(item => removeClass(modalDom, item))
        }

        modalStack.pop()
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex
        }
      } else {
        for (let i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1)
            break
          }
        }
      }
    }

    if (modalStack.length === 0) {
      Dom.removeClass(modalDom, 'v-model-fade-leave')
      setTimeout(() => {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom)
          modalDom.style.display = 'none'
          Popup.modalDom = undefined
        }
      }, 400)
    }
  }
}

Object.defineProperty(Popup, 'zIndex', {
  configurable: true,
  get () {
    if (!hasInitZIndex) {
      zIndex = (Vue.prototype.$ELEMENT || {}).zIndex || zIndex
      hasInitZIndex = true
    }
    return zIndex
  },
  set (value) {
    zIndex = value
  }
})

const getTopPopup = function () {
  if (Vue.prototype.$isServer) return
  if (Popup.modalStack.length > 0) {
    const topPopup = Popup.modalStack[Popup.modalStack.length - 1]
    if (!topPopup) return
    const instance = Popup.getInstance(topPopup.id)
    return instance
  }
}

if (!Vue.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      const topPopup = getTopPopup()

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose
          ? topPopup.handleClose()
          : (topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close())
      }
    }
  })
}

export default Popup



// WEBPACK FOOTER //
// ./src/utils/popup.js